// import { useNavigate } from "react-router-dom";
// import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";
// import { useAppSelector } from "@/hooks/reduxHooks";

function InvalidAuthorization() {
    // const navigate = useNavigate();
    // const { profile } = useAppSelector((state) => state.account);

    // const handleGoBack = () => {
    //     navigate(-1);
    // };

    // const handleGoHome = () => {
    //     navigate('/');
    // };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-950 px-4">
            <div className="max-w-md w-full bg-white dark:bg-slate-900 rounded-lg shadow-md p-8 text-center">
                <div className="flex justify-center mb-6">
                    <ShieldX className="w-16 h-16 text-red-500" />
                </div>

                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    Invalid Authorization
                </h1>

                <p className="text-gray-600 dark:text-gray-300 mb-6">
                    You are not authorized to access this page. Your session may have expired or you may not have the required permissions.
                </p>

                {/* <div className="space-y-3">
                    <Button 
                        onClick={handleGoBack}
                        variant="outline"
                        className="w-full flex items-center justify-center gap-2"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Go Back
                    </Button>
                    
                    <Button 
                        onClick={handleGoHome}
                        className="w-full"
                    >
                        Go to Home
                    </Button>
                </div> */}

                <p className="text-sm text-gray-500 mt-6">
                    If you believe this is an error, please contact support.
                </p>
            </div>
        </div>
    );
}

export default InvalidAuthorization;